export default "__VITE_ASSET__DUmUWkU2__";